/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DoctorExtraSpecialtyStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
}
